import { useLazyQuery } from "@apollo/client";
import { GET_PAST_PETS } from "./past-pets.query";
import { IGetRetiredPets } from "./past-pets.interface";

export const usePastPetsList = () => {
  const [getPastPets, { data, loading }] =
    useLazyQuery<{ getRetiredPets: IGetRetiredPets }>(GET_PAST_PETS);

  return {
    getPastPets,
    pastPetsList: data?.getRetiredPets?.pets,
    loading,
  };
};

